import { getChassisPdfFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getChassisPdf/getChassisPdfQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getChassisPdfQueryOptions = ({
  enabled,
  vehicle_type,
}: {
  enabled: boolean;
  vehicle_type: string;
}) => {
  return queryOptions({
    queryKey: ['chassisPdf', vehicle_type],
    queryFn: () => getChassisPdfFunction({ vehicle_type }),
    enabled: enabled,
  });
};
